import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/lucide-react@1.63.0_@types+react@19.3.0_react@19.3.1/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.4.3_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@types+node@24.19.2_react-dom@19.3.1_react@19.3.1__react@19.3.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/app/node_modules/.pnpm/next@16.4.3_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@types+node@24.19.2_react-dom@19.3.1_react@19.3.1__react@19.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["CampaignBoundary"] */ "/app/src/ui/components/black-friday/campaign-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductBadges"] */ "/app/src/ui/components/catalog/product-badges.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductQualityNote"] */ "/app/src/ui/components/catalog/product-quality-note.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RetailReferralLink"] */ "/app/src/ui/components/commerce/retail-referral-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AddToCartForm"] */ "/app/src/ui/components/pdp/add-to-cart-form.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/ui/components/pdp/add-to-cart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BacCrossSellQtyPicker"] */ "/app/src/ui/components/pdp/bac-cross-sell-card-client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/ui/components/pdp/back-in-stock-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BundleSaveButton"] */ "/app/src/ui/components/pdp/bundle-save-button.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/ui/components/pdp/dose-picker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExpressShippingTooltip"] */ "/app/src/ui/components/pdp/express-shipping-badge-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PdpDescriptionCollapsible"] */ "/app/src/ui/components/pdp/pdp-description-collapsible.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/ui/components/pdp/pdp-faq-inline.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/ui/components/pdp/pdp-layout.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["PosthogDistinctIdField"] */ "/app/src/ui/components/pdp/posthog-distinct-id-field.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductGallery"] */ "/app/src/ui/components/pdp/product-gallery.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/ui/components/pdp/product-reviews.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductViewedTracker"] */ "/app/src/ui/components/pdp/product-viewed-tracker.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/ui/components/pdp/quantity-picker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewSnippet"] */ "/app/src/ui/components/pdp/review-snippet.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StarRating"] */ "/app/src/ui/components/pdp/star-rating.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/ui/components/pdp/sticky-bar.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/ui/components/pdp/stock-indicator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TotalStepperAtcCard"] */ "/app/src/ui/components/pdp/total-stepper-atc-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PdpVariantNavigationProvider"] */ "/app/src/ui/components/pdp/variant-navigation-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VariantSectionErrorBoundary"] */ "/app/src/ui/components/pdp/variant-section-error-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VariantSectionError"] */ "/app/src/ui/components/pdp/variant-section-error.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/ui/components/pdp/variant-selection/renderers/button-option.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/ui/components/pdp/variant-selection/renderers/color-swatch-option.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VariantNameSelector"] */ "/app/src/ui/components/pdp/variant-selection/variant-name-selector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VariantSelectionSection"] */ "/app/src/ui/components/pdp/variant-selection/variant-selection-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VariantSelector"] */ "/app/src/ui/components/pdp/variant-selection/variant-selector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReferencePrimaryPrice"] */ "/app/src/ui/components/pricing/reference-primary-price.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RecentlyViewed"] */ "/app/src/ui/components/recently-viewed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RelatedProductsCarousel"] */ "/app/src/ui/components/related-products-carousel.tsx");
